import styled from "styled-components";

const Img = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export default Img;
